import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const MAIL_FORWARD_FIELDS = gql`
  fragment McadminMailForwardFields on McadminMailForward {
    id
    name
    source
    destination
    domain { id, name }
  }
`;

export const MAIL_FORWARDS = gql`
  ${MAIL_FORWARD_FIELDS}
  query McadminMailForwards {
    mailForwards: mcadminMailForwards {
      ...McadminMailForwardFields
    }
    domains: mcadminDomains {
      label: name
      value: id
    }
  }
`;

const MAIL_FORWARD_ARGUMENTS = `
  $name: String!
  $domainId: ID!
  $destination: String!
`;

const MAIL_FORWARD_VARIABLES = `
  name: $name
  domainId: $domainId
  destination: $destination
`;

export const CREATE_MAIL_FORWARD = gql`
  ${MAIL_FORWARD_FIELDS}
  mutation CreateMcadminMailForward (
    ${MAIL_FORWARD_ARGUMENTS}
  ) {
    createMcadminMailForward (
      ${MAIL_FORWARD_VARIABLES}
    ) {
      mailForward {
        ...McadminMailForwardFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_MAIL_FORWARD = gql`
  ${MAIL_FORWARD_FIELDS}
  mutation UpdateMcadminMailForward (
    $id: ID!
    ${MAIL_FORWARD_ARGUMENTS}
  ) {
    updateMcadminMailForward (
      id: $id
      ${MAIL_FORWARD_VARIABLES}
    ) {
      mailForward {
        ...McadminMailForwardFields
      }
      ${ERRORS}
    }
  }
`;

export const DESTROY_MAIL_FORWARD = gql`
  mutation DestroyMcadminMailForward ($id: ID!) {
    destroyMcadminMailForward (id: $id) {
      ${ERRORS}
    }
  }
`;
